function Footer() {
    return (
      <footer style={{
        backgroundColor: "#f2f2f2",
        padding: "40px 20px",
        fontSize: "14px",
        color: "#333",
        marginTop: "60px",
        width: "100%",
        position: "relative",
        zIndex: 1,
        margin: 0,
      }}>
        <div style={{
          maxWidth: "1200px",
          margin: "0 auto",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between"
        }}>
          {/* Bloc gauche */}
          <div style={{ flex: "1 1 250px", marginBottom: "20px" }}>
            <h4 style={{ marginBottom: "10px" }}>Contact</h4>
            <p>Email : X</p>
            <p>Instagram : X</p>
          </div>
  
          {/* Bloc milieu */}
          <div style={{ flex: "1 1 250px", marginBottom: "20px" }}>
            <h4 style={{ marginBottom: "10px" }}>À propos</h4>
            <p>
              Najdi Oud est une boutique spécialisée dans les parfums orientaux
              émiratis et saoudiens. Qualité, authenticité et élégance.
            </p>
          </div>
  
          {/* Bloc droit */}
          <div style={{ flex: "1 1 250px", marginBottom: "20px" }}>
            <h4 style={{ marginBottom: "10px" }}>Navigation</h4>
            <ul style={{ listStyle: "none", padding: 0 }}>
              <li><a href="/" style={{ color: "#333", textDecoration: "none" }}>Accueil</a></li>
              <li><a href="/produits" style={{ color: "#333", textDecoration: "none" }}>Produits</a></li>
              <li><a href="/contact" style={{ color: "#333", textDecoration: "none" }}>Contact</a></li>
            </ul>
          </div>
        </div>
  
        <div style={{
          textAlign: "center",
          marginTop: "40px",
          fontSize: "12px",
          color: "#888"
        }}>
          &copy; {new Date().getFullYear()} Najdi Oud. Tous droits réservés.
        </div>
      </footer>
    );
  }
  
  export default Footer;